import React, {useEffect, useRef} from 'react'
import {toast} from 'react-toastify'

// Certificate pages use the same actionable toast pattern as Crewing deletions.
export function useCertificateDeleteToast(active = true) {
  const enabled = useRef(active)
  const prompts = useRef(new Map<string, () => void>())
  const pending = useRef(new Set<string>())
  enabled.current = active

  useEffect(() => {
    enabled.current = active
    return () => {
      enabled.current = false
      prompts.current.forEach((cancel, id) => {
        cancel()
        toast.dismiss(id)
      })
      prompts.current.clear()
    }
  }, [active])

  return (id: string, message: string, onConfirm: () => Promise<void>) => {
    if (!enabled.current || prompts.current.has(id) || pending.current.has(id) || toast.isActive(id)) return
    let settled = false
    const finish = () => {
      settled = true
      prompts.current.delete(id)
    }
    prompts.current.set(id, finish)
    toast.info(({closeToast}) => (
      <div>
        <div className='mb-2'>{message}</div>
        <div className='d-flex gap-2'>
          <button type='button' className='btn btn-sm btn-danger' onClick={async () => {
            if (settled || !enabled.current) return
            finish()
            pending.current.add(id)
            closeToast?.()
            try {
              await onConfirm()
            } finally {
              pending.current.delete(id)
            }
          }}>
            Delete
          </button>
          <button type='button' className='btn btn-sm btn-light' onClick={() => {
            finish()
            closeToast?.()
          }}>
            Cancel
          </button>
        </div>
      </div>
    ), {
      toastId: id,
      position: 'top-center',
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      onClose: finish,
    })
  }
}
